module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "image-upload-step"
    }
  }, [_c('step-template', [_c('div', {
    attrs: {
      "slot": "back"
    },
    on: {
      "click": _vm.back
    },
    slot: "back"
  }, [_vm._v("←")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('div', {
    staticClass: "mb-4 md:mb-6"
  }, [_vm._v("Now, upload an image (not a selfie!) that best reflects your experience of nature or society in your local area.")]), _vm._v(" "), _c('img', {
    staticClass: "block mb-4",
    attrs: {
      "src": require("../assets/img/examples.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-sm mb-4 md:mb-6 opacity-50"
  }, [_vm._v("Please make sure you have taken this picture yourself or have permission to upload it.")]), _vm._v(" "), _c('input', {
    ref: "fileinput",
    staticClass: "mb-6 md:mb-8 text-grey w-5/6",
    attrs: {
      "type": "file",
      "id": "input"
    },
    on: {
      "change": _vm.fileInputChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('csf-button', {
    staticClass: "mr-4 self-start",
    attrs: {
      "type": "primary",
      "disabled": !_vm.fileHasBeenSelected || !_vm.fileExtension || _vm.isUploading || _vm.fileTooLarge
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(_vm.noFileError) ? _c('div', {
    staticClass: "text-sm md:text-base flex items-center"
  }, [_vm._v("Please select an image to upload.")]) : (_vm.fileHasBeenSelected && !_vm.fileExtension) ? _c('div', {
    staticClass: "text-sm md:text-base flex items-center"
  }, [_vm._v("The image needs to be in JPEG or PNG format to upload.")]) : (_vm.fileHasBeenSelected && _vm.fileExtension && _vm.fileTooLarge) ? _c('div', {
    staticClass: "text-sm md:text-base flex items-center"
  }, [_vm._v("The image needs to be under 5 Mb.")]) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a80eaf3","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/ImageUploadStep.vue
// module id = 168
// module chunks = 0